import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { avatarTheme, avatarSize } from './styles'

const SkeletonAvatar = ({ theme, size, round, className }) => (
  <figure className={cx(styles.avatar, className, avatarTheme(theme), avatarSize(size), round && styles.rounded)} />
)

SkeletonAvatar.propTypes = {
  theme: PropTypes.oneOf(['', 'light', 'dark']),
  size: PropTypes.oneOf(['', 'small', 'default', 'medium', 'large', 'extraLarge', 'extraExtraLarge']),
  round: PropTypes.bool,
  className: PropTypes.string,
}

SkeletonAvatar.defaultProps = {
  theme: 'light',
  size: 'default',
}

export default SkeletonAvatar
